import React, { useEffect, useState } from "react";
import { useIntl } from "react-intl";
import { useDispatch, useSelector } from "react-redux";
import { editAccessCode } from 'actions/AccessCodes';
import { toastManager } from "components/ToastNotification";
import TextInput from "components/TextInput";
import ButtonContained from "components/ButtonContained";

const UserSettingsAccessCodeModal = () => {
  const intl = useIntl();
  const dispatch = useDispatch();
  const user = useSelector(state => state.users.userObject);
  const userUnits = useSelector(state => state.users.userUnits);
  const [accessCode, setAccessCode] = useState(userUnits?.[0]?.accessCodes[0]?.accessCode);

  useEffect(() => {
    if (userUnits) {
      setAccessCode(userUnits[0]?.accessCodes[0]?.accessCode);
    }
  }, [userUnits]);

  const handleEditAccessCode = () => {
    if (accessCode.length && accessCode.length < 4) {
      toastManager.addToast(intl.formatMessage({ id: "notifications.error.fail.accessCode.short" }));
      return;
    }
    if (accessCode.length && accessCode.length > 12) {
      toastManager.addToast(intl.formatMessage({ id: "notifications.error.fail.accessCode.long" }));
      return;
    }
    dispatch(editAccessCode(
      {
        unitUUIDs: userUnits.map(u => u.uuid),
        userUUID: user.uuid,
        accessCode
      },
      {
        successMessage: intl.formatMessage({ id: "notifications.success.edit" })
      }
    ))
  }

  return (
    <div className="min-h-[300px] px-10 pt-4 flex flex-col justify-between gap-8">
      <div>
        <div>
          <h5 className="tw-heading-5 mb-8">{intl.formatMessage({ id: "pages.accessCodes.Type" })}</h5>
        </div>
        <TextInput
          id="User-Settings-Access-Code-Name-Input"
          dataCy="User-Settings-Access-Code-Name-Input"
          placeholder={intl.formatMessage({id: "form.accessCode"})}
          onChange={(e) => setAccessCode(e.target.value)}
          value={accessCode}
          validateInput={(val) => /^\d*$/.test(val)}
        />
      </div>
      <div>
        <ButtonContained
          id="User-Settings-Access-Code-Save-Changes-Button"
          dataCy="User-Settings-Access-Code-Save-Changes-Button"
          text={intl.formatMessage({ id: "comp.button.saveChanges" })}
          type="medium"
          disabled={userUnits?.[0]?.accessCodes[0]?.accessCode === accessCode}
          onClick={handleEditAccessCode}
        />
      </div>
    </div>
  )
};

export default UserSettingsAccessCodeModal;